/**
 * Utility for forcing certain listings (profiles) to the front in a specific order
 * while keeping the rest in their original relative order.
 *
 * Used by SearchPage and featured sections (LandingPage, ChooseTesterPage).
 */
export const sortListingsByPriorityUUIDs = (listings, priorityUUIDs) => {
  const list = Array.isArray(listings) ? listings : [];
  const priority = Array.isArray(priorityUUIDs) ? priorityUUIDs.filter(Boolean) : [];

  if (priority.length === 0 || list.length === 0) {
    return list;
  }

  const indexByUuid = priority.reduce((acc, uuid, index) => {
    // Only keep the first occurrence.
    if (acc[uuid] == null) {
      acc[uuid] = index;
    }
    return acc;
  }, {});

  const prioritySet = new Set(priority);

  const priorityListings = [];
  const otherListings = [];

  for (const listing of list) {
    const uuid = listing?.id?.uuid;
    if (uuid && prioritySet.has(uuid)) {
      priorityListings.push(listing);
    } else {
      otherListings.push(listing);
    }
  }

  priorityListings.sort((a, b) => {
    const aIdx = indexByUuid[a.id.uuid] ?? Number.MAX_SAFE_INTEGER;
    const bIdx = indexByUuid[b.id.uuid] ?? Number.MAX_SAFE_INTEGER;
    return aIdx - bIdx;
  });

  return [...priorityListings, ...otherListings];
};

